<template>
    <div  class="modal-cancel-overlay">
     
        <form @submit.prevent="saveCancellation()">
            <div class="cancel-modal">
              <div class="modal-header">
                    <a class="close-btn" ria-label="Close"
                    @click.prevent="$emit('close', false)">
                    <img
                      src="@/assets/images/modal-close.png"
                      alt="Close modal button"
                    />
                </a>
              </div>
            <h3 class="modal-title">Request to Cancel Application</h3>
            <p class="modal-text">
              Select applicant requesting to cancel the application
            </p>
            <select class="modal-options" v-model="cancellation.applicantId" required>
              <option value="0">-- Select Applicant --</option>
              <option
                v-if="applicationStore.viewModel.hasPrimaryApplicant"
                :value="applicationStore.viewModel.primaryApplicant.id"
              >
                {{ applicationStore.viewModel.primaryApplicant.fullName }} -
                {{ applicationStore.viewModel.primaryApplicant.applicantTypeName }}
              </option>
              <option
                v-if="applicationStore.viewModel.hasCoApplicant"
                :value="applicationStore.viewModel.coApplicant.id"
              >
                {{ applicationStore.viewModel.coApplicant.fullName }} -
                {{ applicationStore.viewModel.coApplicant.applicantTypeName }}
              </option>
            </select>
            <p class="modal-text">
              Please select the reason this application is being cancelled
            </p>
            <select class="modal-options" @change="handleReasonChange" v-model="cancellation.statusReasonId" required>
              <option value="0">-- Select Reason --</option>
              <option v-for="reason in statusReasons" 
                :key="reason.id" :value="reason.id">
                {{ reason.name }}
              </option>
            </select>
            <div class="modal-text-attest-container">
              <p class="modal-text-attest">
                Canceling this application during the Right to Cancel period
                cannot be reversed. Do you wish to proceed?
              </p>
            </div>
            <div class="modal-button-container">
            <button type="button" @click="emit('close', false)" class="modal-btn no-btn" > 
                <span>No</span>
              </button>
              <button type="submit" class="modal-btn yes-btn">
                <span>Yes</span>
              </button>
            </div>
          </div>
        </form>
      </div>
</template>
<script setup lang="ts">
    import axios from "axios";
    import { LOSType, Type } from "@/types/types";
    import { useApplicationStore } from "@/store/store/applicationVMStore";
    import { useTypeStore } from "@/store/store/typeStore";
    import { ref, computed } from "vue";
    import {Cancellation} from "@/types/application";
    import functions from "@/use/functions";

    const emit = defineEmits<{
      (event: 'close', payload: boolean): void;
      (event: 'update'): void;
    }>();

    const typeStore = useTypeStore();
    const applicationStore = useApplicationStore();
    const cancellation = ref<Cancellation>({
       statusReasonId: 0,
       applicantId: 0,
       cancellationReason: ""
    });

    const statusReasons = computed(() =>
        typeStore.getTypes(Type.ApplicationStatusReasons)
    );

    const handleReasonChange = () => {
        var status = statusReasons.value.find(r => r.id == cancellation.value.statusReasonId);

        if(status !== undefined){
           cancellation.value.cancellationReason = status.name || "";
        }
    }

    const saveCancellation = async () => {
      try {
          var response = await axios.post(`/api/applications/${applicationStore.applicationId}/Refi/Cancel`, cancellation.value);
          
          if(response.data.success)
          {
            emit('update');
            emit('close', false);

            functions.openModal({
                title: "Success!",
                description: "Application has been saved",
            });
          }else{

            const modal = {
              title: "Error",
              description: response.data.errors.join(",") || "Failed to save cancellation request",
            };

            functions.openModal(modal);
          }
      }catch(error){
         emit('close', false);

         const modal = {
              title: "Error",
              description: error.response.data || "Failed to save cancellation request",
          };

          functions.openModal(modal);
      }
  }
</script>
<style scoped>
.cancel-modal {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 640px;
  height: 460px;
  text-align: center;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

.modal-cancel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-options {
  margin-bottom: 20px;
}


.modal-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}


.modal-header .close-btn {
  margin: 0 0 -1rem auto;
  padding: 1rem;
}

.modal-header .close-btn img {
  height: 18px;
  width: 18px;
}

.modal-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 20px;
}

.modal-text {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 20px;
}

.modal-text-attest {
  font-weight: 600;
}

.modal-text-attest-container {
  justify-content: center;
  margin-bottom: 20px;
  align-items: center;
  text-align: center;
}

.modal-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.modal-btn {
  width: 100px;
  height: 42px;
  margin: 0 10px;
  border-radius: 6px;
  font-weight: 600;
}

.yes-btn {
  background-color: black;
  color: white;
}
.no-btn {
  background-color: #eeeff2;
  color: black;
}
</style>